/**
 * Validates a mobile number for the selected country.
 * Country code prefix is handled separately via the dropdown.
 */
function validatePhoneNumber(value, countryCode) {
  if (!value) return { valid: false, error: "Mobile number is required" };

  const cleaned = value.replace(/\D/g, "");

  if (countryCode === "+91") {
    if (!/^[6-9]\d{9}$/.test(cleaned)) {
      return { valid: false, error: "Enter a valid 10-digit Indian mobile number" };
    }
    return { valid: true, error: null };
  }

  if (countryCode === "+86") {
    if (!/^1[3-9]\d{9}$/.test(cleaned)) {
      return { valid: false, error: "Enter a valid 11-digit Chinese mobile number" };
    }
    return { valid: true, error: null };
  }

  // ITU-T E.164 allows 7-15 digits for countries without a specific rule here.
  if (cleaned.length < 7 || cleaned.length > 15) {
    return { valid: false, error: "Enter a valid mobile number" };
  }

  return { valid: true, error: null };
}

function validateEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
}

function validatePassword(password) {
    return password.length >= 6; // Example: password must be at least 6 characters long
}

function validateRegistrationForm(formData) {
    const { email, password, confirmPassword } = formData;
    const errors = {};

    if (!validateEmail(email)) {
        errors.email = "Invalid email address";
    }

    if (!validatePassword(password)) {
        errors.password = "Password must be at least 6 characters long";
    }

    if (password !== confirmPassword) {
        errors.confirmPassword = "Passwords do not match";
    }

    return {
        isValid: Object.keys(errors).length === 0,
        errors,
    };
}

export const productChecklist = (product) => {
  const media = product.media || [];

  const imageCount = media.filter(
    (m) =>
      m.type === "image" ||
      m.mimeType?.startsWith("image/")
  ).length;

  const videoCount = media.filter(
    (m) =>
      m.type === "video" ||
      m.mimeType?.startsWith("video/")
  ).length;

  return [
    {
      label: "Product title added",
      ok: !!product.title,
      requiredForSubmit: true,
    },
    {
      label: "Product description added",
      ok: !!product.description,
      requiredForSubmit: true,
    },
    {
      label: "At least 1 product image added",
      ok: imageCount >= 1,
      requiredForSubmit: true,
    },
    {
      label: "At least 1 product video added",
      ok: videoCount >= 1,
      requiredForSubmit: true,
    },
    {
      label: "Price set",
      ok: Number(product.price) > 0,
      requiredForSubmit: true,
    },
  ];
};


export { validateEmail, validatePassword, validateRegistrationForm, validatePhoneNumber };